export enum AlignItems {
  start,
  end,
  center,
  stretch,
  baseline,
}
